import { Switch, Route } from "react-router";
import React from "react";

import Devices from "./devices";
import ApiKeys from "./api-keys";
import ChangePassword from "./change-password";

const userRouter = () => (
  <Switch>
    <Route path="/user/password" render={() => <ChangePassword />} />
    <Route path="/user/devices" render={() => <Devices />} />
    <Route path="/user/apikeys" render={() => <ApiKeys />} />
  </Switch>
);

export default userRouter;
